/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import Select from 'react-select';
import {
  GetPermissionsByRuleId,
  GetPermissionsByUserId,
  UpdatePermissionRole,
  UpdatePermissionUser
} from '@store/NTX/Security/Permission/PermissionSlice';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useLookupModule from '@hooks/Lookups/use-Lookup-Module';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardBody, CardHeader } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import confirmAction from '@components/Shared/Alert/confirmAction';
import NoData from '@components/NoData/NoData';

// const Permissions: React.FC<{ type: 'rule' | 'user' }> = ({ type }) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { refrenceId } = useParams();
//   const [moduleId, setModuleId] = useState<string>('');
//   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
//   const { OptionsModule, loading: loading2 } = useLookupModule();

//   //__
//   const { PermissionList, loading, error } = useAppSelector(state => state.Permission);

//   const DynamicPermission = [
//     ...new Map(
//       PermissionList?.dynamic?.map(p => [
//         p.permissionType, // This acts as the unique key
//         {
//           type: p.permissionType,
//           permissionTypeName: i18n.language === 'en' ? p.permissionTypeName : p.permissionTypeName2,
//           withModuleId: p.withModuleId
//         }
//       ])
//     )?.values()
//   ];
//   //__

//   const [checkedPermissions, setCheckedPermissions] = useState<{
//     [key: string]: boolean;
//   }>({});

//   const [checkedPermissionsDynamic, setCheckedPermissionsDynamic] = useState<{
//     [key: string]: boolean;
//   }>({});

//   //______________________________
//   useEffect(() => {
//     if (type === 'user' && refrenceId) {
//       dispatch(GetPermissionsByUserId(refrenceId));
//     }

//     if (type === 'rule' && refrenceId) {
//       dispatch(GetPermissionsByRuleId(refrenceId));
//     }
//   }, [dispatch, type, refrenceId]);

//   //______________________________

//   useEffect(() => {
//     if (PermissionList && PermissionList.menuWithPermissions) {
//       const newCheckedPermissions: { [key: string]: boolean } = {};
//       PermissionList.menuWithPermissions.forEach(menu => {
//         menu.permissions.forEach(permission => {
//           newCheckedPermissions[permission.id] = permission?.hasPermission;
//         });
//       });
//       setCheckedPermissions(newCheckedPermissions);
//     }

//     if (PermissionList && PermissionList.dynamic) {
//       const newCheckedPermissionsDynamic: { [key: string]: boolean } = {};
//       PermissionList.dynamic.forEach(m => {
//         newCheckedPermissionsDynamic[m.id] = m?.hasPermission;
//       });
//       setCheckedPermissionsDynamic(newCheckedPermissionsDynamic);
//     }
//   }, [PermissionList]);

//   const handleCheckboxChange = (Id: string, type: 'General' | 'Reports' | 'Ame' | 'dynamic') => {
//     if (type === 'General') {
//       // Id : PermissionId
//       setCheckedPermissions(prevCheckedPermissions => ({
//         ...prevCheckedPermissions,
//         [Id]: !prevCheckedPermissions[Id]
//       }));
//     }

//     if (type === 'dynamic') {
//       setCheckedPermissionsDynamic(prevCheckedPermissionsDynamic => ({
//         ...prevCheckedPermissionsDynamic,
//         [Id]: !prevCheckedPermissionsDynamic[Id]
//       }));
//     }
//   };

//   const handleUpdatePermission = async () => {
//     const msg =
//       i18n.language === 'en'
//         ? 'Permissions will be updated according to the new changes. Do you want to proceed and save?'
//         : 'سيتم تحديث الصلاحيات وفق التغييرات الجديدة. هل تريد المتابعة وحفظ التغييرات؟';

//     const isConfirmation = await confirmAction(msg);
//     if (!isConfirmation) {
//       return;
//     }
//     setIsSubmitting(true);

//     const RequestBody = {
//       refrenceId: refrenceId,
//       permissions: {
//         withIn: Object.entries(checkedPermissions)
//           ?.filter(([, checked]) => checked)
//           ?.map(([Id]) => Id),
//         withOute: Object.entries(checkedPermissions)
//           ?.filter(([, checked]) => !checked)
//           ?.map(([Id]) => Id)
//       },

//       dynamic: {
//         withIn: Object.entries(checkedPermissionsDynamic)
//           ?.filter(([, checked]) => checked)
//           ?.map(([Id]) => ({
//             id: Id,
//             permissionType: PermissionList?.dynamic?.find(f => f.id === Id)?.permissionType
//           })),
//         withOute: Object.entries(checkedPermissionsDynamic)
//           ?.filter(([, checked]) => !checked)
//           ?.map(([Id]) => ({
//             id: Id,
//             permissionType: PermissionList?.dynamic?.find(f => f.id === Id)?.permissionType
//           }))
//       }
//     };

//     try {
//       const updateAction = type === 'user' ? UpdatePermissionUser : UpdatePermissionRole;
//       const getPermissionsAction = type === 'user' ? GetPermissionsByUserId : GetPermissionsByRuleId;

//       const res = await dispatch(updateAction(RequestBody)).unwrap();
//       if (res?.succeeded) {
//         dispatch(getPermissionsAction(refrenceId || ''));
//         CustomAlert({ action: 'Add', msg: 'تم حفظ التغييرات' });
//       } else {
//         CustomAlert({ action: 'Error' });
//       }
//     } catch (err: any) {
//       console.error('Error updating permissions:', err);
//       CustomAlert({ action: 'Error' });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   //________________________________________________________________
//   const handleSelectAll = (
//     type: 'General' | 'Reports' | 'Ame' | 'dynamic' | 'module',
//     menuId?: string | null,
//     action?: boolean,
//     permissionType?: string
//   ) => {
//     if (type === 'General') {
//       const updatedPermissions = { ...checkedPermissions };
//       PermissionList?.menuWithPermissions
//         ?.filter(menu => menu.menuId === menuId)
//         ?.forEach(menu => {
//           menu.permissions.forEach(permission => {
//             updatedPermissions[permission.id] = action ?? true;
//           });
//         });
//       setCheckedPermissions(updatedPermissions);
//     }

//     if (type === 'dynamic') {
//       const updatedPermissionsDynamic = { ...checkedPermissionsDynamic };
//       PermissionList?.dynamic
//         ?.filter(f => f.permissionType === permissionType)
//         ?.forEach(dynamicPermission => {
//           updatedPermissionsDynamic[dynamicPermission.id] = action ?? true;
//         });
//       setCheckedPermissionsDynamic(updatedPermissionsDynamic);
//     }

//     // New case for selecting all permissions under a specific moduleId
//     if (type === 'module' && moduleId) {
//       const updatedPermissions = { ...checkedPermissions };

//       PermissionList?.menuWithPermissions
//         ?.filter(menu => menu.moduleId === moduleId)
//         ?.forEach(menu => {
//           menu.permissions.forEach(permission => {
//             updatedPermissions[permission.id] = action ?? true;
//           });
//         });

//       setCheckedPermissions(updatedPermissions);
//     }
//   };

//   const getIconForType = (type: string) => {
//     switch (type) {
//       case 'Dashboard':
//         return <i className='fa fa-tachometer-alt fa-fw me-2 text-theme'></i>; // Example icon for Dashboard
//       case 'Report':
//         return <i className='fa fa-file-alt fa-fw me-2 text-theme'></i>; // Example icon for Report
//       case 'Ame':
//         return <i className='fa fa-tasks fa-fw me-2 text-theme'></i>; // Example icon for Ame
//       case 'Inventory':
//         return <i className='fa fa-warehouse fa-fw me-2 text-theme'></i>; // Example icon for Inventory
//       case 'Branch':
//         return <i className='fa fa-code-branch fa-fw me-2 text-theme'></i>; // Example icon for Branch
//       default:
//         return <i className='fa fa-folder fa-fw me-2 text-theme'></i>; // Default icon if type not found
//     }
//   };

//   const [activeTab, setActiveTab] = useState('');

//   return (
//     <>
//       <Loading loading={loading} error={error}>
//         <Card className='   '>
//           <CardHeader className='m-0'>
//             <div className='row  pt-2'>
//               <div className='col-xl-6'>
//                 <div className='d-flex align-items-center gap-2 mb-3'>
//                   {/* Select box */}
//                   <div className='flex-grow-1'>
//                     <div className='input-group flex-nowrap'>
//                       <span className='input-group-text'>{t('Application')}</span>
//                       <Select
//                         classNamePrefix='react-select'
//                         className='w-100'
//                         isLoading={loading2}
//                         isSearchable={true}
//                         isClearable
//                         options={OptionsModule}
//                         onChange={(option: any) => {
//                           setModuleId(option === null ? null : option.value);
//                           setActiveTab('');
//                         }}
//                         placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         menuPortalTarget={document.body}
//                         styles={{
//                           menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className='col-xl-4'>
//                 {moduleId && (
//                   <div className='d-flex gap-2'>
//                     <button
//                       type='button'
//                       className='btn btn-outline-theme  '
//                       onClick={() => handleSelectAll('module', null, true)}
//                     >
//                       <i className='fas fa-check-square me-2'></i>
//                       {t('SelectAll')}
//                     </button>
//                     <button
//                       type='button'
//                       className='btn btn-outline-theme  '
//                       onClick={() => handleSelectAll('module', null, false)}
//                     >
//                       <i className='fas fa-square me-2'></i>
//                       {t('UnSelectAll')}
//                     </button>
//                   </div>
//                 )}
//               </div>

//               <div className='col-xl-2 text-end'>
//                 <button
//                   disabled={isSubmitting}
//                   type='button'
//                   className='btn  me-1 btn-theme  '
//                   onClick={() => handleUpdatePermission()}
//                 >
//                   {isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fa fa-save fa-fw me-2'></i>
//                   )}
//                   {t('Save')}
//                 </button>
//               </div>
//             </div>
//           </CardHeader>

//           <CardBody className='p-0'>
//             <ul className='nav nav-tabs nav-tabs-v2 pt-1 px-3'>
//               <li className='nav-item me-1 dropdown'>
//                 <Link
//                   to='#/'
//                   className='nav-link dropdown-toggle me-1 bg-theme bg-opacity-25 px-2'
//                   data-bs-toggle='dropdown'
//                 >
//                   <i className='fa fa-sliders-h fa-fw me-2 text-theme'></i>
//                   {t('ApplicationPermissions')}{' '}
//                 </Link>
//                 <div className='dropdown-menu text-center'>
//                   {PermissionList &&
//                     PermissionList?.menuWithPermissions
//                       ?.filter(f => f.moduleId === moduleId)
//                       .sort((a, b) => a.sequence - b.sequence)
//                       ?.map(item => (
//                         <Link
//                           to={`#${item.menuId}`}
//                           key={item.menuId}
//                           className='dropdown-item'
//                           onClick={() => setActiveTab(item.menuId)}
//                           data-bs-toggle='tab'
//                         >
//                           {i18n.language === 'ar' ? item.name2 : item.name}
//                         </Link>
//                       ))}
//                 </div>
//               </li>
//               {DynamicPermission?.map(item => (
//                 <li className='nav-item me-3' key={item.type}>
//                   <Link to={`#${item.type}`} className='nav-link' data-bs-toggle='tab'>
//                     {getIconForType(item.type)}
//                     {item.permissionTypeName}
//                   </Link>
//                 </li>
//               ))}
//             </ul>

//             <div className='tab-content p-4'>
//               {PermissionList?.menuWithPermissions?.map(item => {
//                 const filteredPermissions =
//                   item.permissions
//                     ?.slice()
//                     ?.filter(f => f.menuId === item.menuId)
//                     ?.sort((a, b) => a.sequence - b.sequence) || [];

//                 return (
//                   <div
//                     className={`tab-pane fade ${activeTab === item.menuId ? 'show active' : ''}`}
//                     id={item.menuId}
//                     key={item.menuId}
//                   >
//                     <div className='d-flex justify-content-end mb-2'>
//                       <button
//                         type='button'
//                         className='btn btn-sm btn-outline-theme mx-1'
//                         onClick={() => handleSelectAll('General', item.menuId, true)}
//                       >
//                         <i className='fas fa-check-square me-2'></i>
//                         {t('SelectAll')}
//                       </button>
//                       <button
//                         type='button'
//                         className='btn btn-sm btn-outline-theme mx-1'
//                         onClick={() => handleSelectAll('General', item.menuId, false)}
//                       >
//                         <i className='fas fa-square me-2'></i>
//                         {t('UnSelectAll')}
//                       </button>
//                     </div>

//                     <div className='row'>
//                       {filteredPermissions.length > 0 ? (
//                         filteredPermissions.map(m => (
//                           <div className='col-md-4 mb-2' key={m.id}>
//                             <div
//                               className={`p-3 rounded-2  permission-item  fw-bold
//                                  ${
//                                    checkedPermissions[m.id]
//                                      ? ' border-theme border border-1 bg-theme bg-opacity-20'
//                                      : ' border-theme border-bottom bg-inverse bg-opacity-10'
//                                  }`}
//                               onClick={() => handleCheckboxChange(m.id, 'General')}
//                               style={{ cursor: 'pointer' }}
//                             >
//                               <div className='form-check'>
//                                 <label className='form-check-label' htmlFor={`${m.id}`}>
//                                   <input
//                                     className='form-check-input'
//                                     type='checkbox'
//                                     id={`${m.id}`}
//                                     checked={checkedPermissions[m.id] || false}
//                                     onChange={() => {}}
//                                     onClick={e => e.stopPropagation()}
//                                   />
//                                   {i18n.language === 'ar' ? m.name2 : m.name}
//                                 </label>
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       ) : (
//                         <div className='col-12'>
//                           <NoData />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}

//               {DynamicPermission?.map((item, index) => {
//                 // تصفية الصلاحيات الديناميكية لنوع معين
//                 const filteredDynamic =
//                   PermissionList?.dynamic
//                     ?.filter(f => f.permissionType === item.type)
//                     ?.filter(f => !f.moduleId || f.moduleId === moduleId) || [];

//                 return (
//                   <div className='tab-pane fade' id={item.type} key={index}>
//                     <div className='d-flex justify-content-end mb-2'>
//                       <button
//                         type='button'
//                         className='btn btn-sm btn-outline-theme mx-1'
//                         onClick={() => handleSelectAll('dynamic', '', true, item.type)}
//                       >
//                         <i className='fas fa-check-square me-2'></i>
//                         {t('SelectAll')}
//                       </button>
//                       <button
//                         type='button'
//                         className='btn btn-sm btn-outline-theme mx-1'
//                         onClick={() => handleSelectAll('dynamic', '', false, item.type)}
//                       >
//                         <i className='fas fa-square me-2'></i>
//                         {t('UnSelectAll')}
//                       </button>
//                     </div>
//                     <div className='row g-2'>
//                       {filteredDynamic.length > 0 ? (
//                         filteredDynamic.map(m => (
//                           <div className='col-md-4 mb-2' key={m.id}>
//                             <div
//                               className={`p-3 rounded-2  permission-item  fw-bold  ${
//                                 checkedPermissionsDynamic[m.id]
//                                   ? ' border-theme border border-1 bg-theme bg-opacity-20'
//                                   : ' border-theme border-bottom bg-inverse bg-opacity-10'
//                               }`}
//                               onClick={() => handleCheckboxChange(m.id, 'dynamic')}
//                               style={{ cursor: 'pointer' }}
//                             >
//                               <div className='form-check'>
//                                 <label className='form-check-label' htmlFor={`${m.id}`}>
//                                   <input
//                                     className='form-check-input '
//                                     type='checkbox'
//                                     id={`${m.id}`}
//                                     checked={checkedPermissionsDynamic[m.id] || false}
//                                     onChange={() => {}}
//                                     onClick={e => e.stopPropagation()}
//                                   />
//                                   {i18n.language === 'ar' ? m.name2 : m.name}
//                                 </label>
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       ) : (
//                         <div className='col-12'>
//                           <NoData />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </CardBody>
//         </Card>
//       </Loading>

//       <style>
//         {`
//           .permission-item {
//             transition: all 0.3s ease;
//             cursor: pointer;
//           }

//           .permission-item:hover {
//             background-color: rgba(var(--bs-theme-rgb), 0.4) !important;
//             transform: translateY(-2px);
//             box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
//           }
//         `}
//       </style>
//     </>
//   );
// };

////----------------------------------------------------------------------------------------------------------------

const Permissions: React.FC<{ type: 'rule' | 'user' }> = ({ type }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { refrenceId } = useParams();
  const [moduleId, setModuleId] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { OptionsModule, loading: loading2 } = useLookupModule();

  //__
  const { PermissionList, loading, error } = useAppSelector(state => state.Permission);

  const DynamicPermission = [
    ...new Map(
      PermissionList?.dynamic?.map(p => [
        p.permissionType,
        {
          type: p.permissionType,
          permissionTypeName: i18n.language === 'en' ? p.permissionTypeName : p.permissionTypeName2,
          withModuleId: p.withModuleId
        }
      ])
    )?.values()
  ];
  //__

  const [checkedPermissions, setCheckedPermissions] = useState<{
    [key: string]: boolean;
  }>({});

  const [checkedPermissionsDynamic, setCheckedPermissionsDynamic] = useState<{
    [key: string]: boolean;
  }>({});

  // Track changes for visual feedback
  const [originalPermissions, setOriginalPermissions] = useState<{ [key: string]: boolean }>({});
  const [originalDynamicPermissions, setOriginalDynamicPermissions] = useState<{ [key: string]: boolean }>({});

  //______________________________
  useEffect(() => {
    if (type === 'user' && refrenceId) {
      dispatch(GetPermissionsByUserId(refrenceId));
    }

    if (type === 'rule' && refrenceId) {
      dispatch(GetPermissionsByRuleId(refrenceId));
    }
  }, [dispatch, type, refrenceId]);

  //______________________________

  useEffect(() => {
    if (PermissionList && PermissionList.menuWithPermissions) {
      const newCheckedPermissions: { [key: string]: boolean } = {};
      PermissionList.menuWithPermissions.forEach(menu => {
        menu.permissions.forEach(permission => {
          newCheckedPermissions[permission.id] = permission?.hasPermission;
        });
      });
      setCheckedPermissions(newCheckedPermissions);
      setOriginalPermissions(newCheckedPermissions);
    }

    if (PermissionList && PermissionList.dynamic) {
      const newCheckedPermissionsDynamic: { [key: string]: boolean } = {};
      PermissionList.dynamic.forEach(m => {
        newCheckedPermissionsDynamic[m.id] = m?.hasPermission;
      });
      setCheckedPermissionsDynamic(newCheckedPermissionsDynamic);
      setOriginalDynamicPermissions(newCheckedPermissionsDynamic);
    }
  }, [PermissionList]);

  // Check if there are changes to enable save button
  const hasChanges = useMemo(() => {
    const generalChanged = JSON.stringify(checkedPermissions) !== JSON.stringify(originalPermissions);
    const dynamicChanged = JSON.stringify(checkedPermissionsDynamic) !== JSON.stringify(originalDynamicPermissions);
    return generalChanged || dynamicChanged;
  }, [checkedPermissions, checkedPermissionsDynamic, originalPermissions, originalDynamicPermissions]);

  const handleCheckboxChange = (Id: string, type: 'General' | 'Reports' | 'Ame' | 'dynamic') => {
    if (type === 'General') {
      setCheckedPermissions(prevCheckedPermissions => ({
        ...prevCheckedPermissions,
        [Id]: !prevCheckedPermissions[Id]
      }));
    }

    if (type === 'dynamic') {
      setCheckedPermissionsDynamic(prevCheckedPermissionsDynamic => ({
        ...prevCheckedPermissionsDynamic,
        [Id]: !prevCheckedPermissionsDynamic[Id]
      }));
    }
  };

  const handleUpdatePermission = async () => {
    const msg =
      i18n.language === 'en'
        ? 'Permissions will be updated according to the new changes. Do you want to proceed and save?'
        : 'سيتم تحديث الصلاحيات وفق التغييرات الجديدة. هل تريد المتابعة وحفظ التغييرات؟';

    const isConfirmation = await confirmAction(msg);
    if (!isConfirmation) {
      return;
    }
    setIsSubmitting(true);

    const RequestBody = {
      refrenceId: refrenceId,
      permissions: {
        withIn: Object.entries(checkedPermissions)
          ?.filter(([, checked]) => checked)
          ?.map(([Id]) => Id),
        withOute: Object.entries(checkedPermissions)
          ?.filter(([, checked]) => !checked)
          ?.map(([Id]) => Id)
      },

      dynamic: {
        withIn: Object.entries(checkedPermissionsDynamic)
          ?.filter(([, checked]) => checked)
          ?.map(([Id]) => ({
            id: Id,
            permissionType: PermissionList?.dynamic?.find(f => f.id === Id)?.permissionType
          })),
        withOute: Object.entries(checkedPermissionsDynamic)
          ?.filter(([, checked]) => !checked)
          ?.map(([Id]) => ({
            id: Id,
            permissionType: PermissionList?.dynamic?.find(f => f.id === Id)?.permissionType
          }))
      }
    };

    try {
      const updateAction = type === 'user' ? UpdatePermissionUser : UpdatePermissionRole;
      const getPermissionsAction = type === 'user' ? GetPermissionsByUserId : GetPermissionsByRuleId;

      const res = await dispatch(updateAction(RequestBody)).unwrap();
      if (res?.succeeded) {
        dispatch(getPermissionsAction(refrenceId || ''));
        setOriginalPermissions(checkedPermissions);
        setOriginalDynamicPermissions(checkedPermissionsDynamic);

        CustomAlert({
          action: 'Add',
          msg: i18n.language === 'en' ? 'Changes Saved Successfully' : 'تم حفظ التغييرات بنجاح'
        });
      } else {
        CustomAlert({ action: 'Error' });
      }
    } catch (err: any) {
      console.error('Error updating permissions:', err);
      CustomAlert({ action: 'Error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset changes
  const handleResetChanges = () => {
    setCheckedPermissions(originalPermissions);
    setCheckedPermissionsDynamic(originalDynamicPermissions);
  };

  //________________________________________________________________
  const handleSelectAll = (
    type: 'General' | 'Reports' | 'Ame' | 'dynamic' | 'module',
    menuId?: string | null,
    action?: boolean,
    permissionType?: string
  ) => {
    if (type === 'General') {
      const updatedPermissions = { ...checkedPermissions };
      PermissionList?.menuWithPermissions
        ?.filter(menu => menu.menuId === menuId)
        ?.forEach(menu => {
          menu.permissions.forEach(permission => {
            updatedPermissions[permission.id] = action ?? true;
          });
        });
      setCheckedPermissions(updatedPermissions);
    }

    if (type === 'dynamic') {
      const updatedPermissionsDynamic = { ...checkedPermissionsDynamic };
      PermissionList?.dynamic
        ?.filter(f => f.permissionType === permissionType)
        ?.forEach(dynamicPermission => {
          updatedPermissionsDynamic[dynamicPermission.id] = action ?? true;
        });
      setCheckedPermissionsDynamic(updatedPermissionsDynamic);
    }

    if (type === 'module' && moduleId) {
      const updatedPermissions = { ...checkedPermissions };
      PermissionList?.menuWithPermissions
        ?.filter(menu => menu.moduleId === moduleId)
        ?.forEach(menu => {
          menu.permissions.forEach(permission => {
            updatedPermissions[permission.id] = action ?? true;
          });
        });
      setCheckedPermissions(updatedPermissions);
    }
  };

  const getIconForType = (type: string) => {
    switch (type) {
      case 'Dashboard':
        return <i className='fa fa-tachometer-alt fa-fw me-2 text-theme'></i>;
      case 'Report':
        return <i className='fa fa-file-alt fa-fw me-2 text-theme'></i>;
      case 'Ame':
        return <i className='fa fa-tasks fa-fw me-2 text-theme'></i>;
      case 'Inventory':
        return <i className='fa fa-warehouse fa-fw me-2 text-theme'></i>;
      case 'Branch':
        return <i className='fa fa-code-branch fa-fw me-2 text-theme'></i>;
      default:
        return <i className='fa fa-folder fa-fw me-2 text-theme'></i>;
    }
  };

  const [activeTab, setActiveTab] = useState('');

  // Count selected permissions for each category
  const getSelectedCount = (type: 'General' | 'dynamic', filterType?: string) => {
    if (type === 'General') {
      if (filterType === 'module' && moduleId) {
        const modulePermissions =
          PermissionList?.menuWithPermissions
            ?.filter(menu => menu.moduleId === moduleId)
            ?.flatMap(menu => menu.permissions.map(p => p.id)) || [];
        return modulePermissions.filter(id => checkedPermissions[id]).length;
      }
      return Object.values(checkedPermissions).filter(Boolean).length;
    }

    if (type === 'dynamic') {
      const dynamicPermissions =
        PermissionList?.dynamic?.filter(f => !filterType || f.permissionType === filterType)?.map(m => m.id) || [];
      return dynamicPermissions.filter(id => checkedPermissionsDynamic[id]).length;
    }
    return 0;
  };

  const getTotalCount = (type: 'General' | 'dynamic', filterType?: string) => {
    if (type === 'General') {
      if (filterType === 'module' && moduleId) {
        return (
          PermissionList?.menuWithPermissions
            ?.filter(menu => menu.moduleId === moduleId)
            ?.flatMap(menu => menu.permissions).length || 0
        );
      }
      return Object.keys(checkedPermissions).length;
    }

    if (type === 'dynamic') {
      return PermissionList?.dynamic?.filter(f => !filterType || f.permissionType === filterType)?.length || 0;
    }
    return 0;
  };

  return (
    <>
      <Loading loading={loading} error={error}>
        <Card className=''>
          <CardHeader className='m-0'>
            <div className='row pt-2'>
              <div className='col-xl-5'>
                <div className='d-flex align-items-center gap-2 mb-3'>
                  <div className='flex-grow-1'>
                    <div className='input-group flex-nowrap'>
                      <span className='input-group-text'>{t('Application')}</span>
                      <Select
                        classNamePrefix='react-select'
                        className='w-100'
                        isLoading={loading2}
                        isSearchable={true}
                        isClearable
                        options={OptionsModule}
                        onChange={(option: any) => {
                          setModuleId(option === null ? null : option.value);
                          setActiveTab('');
                        }}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-xl-4'>
                {moduleId && (
                  <div className='d-flex gap-2 align-items-center'>
                    <button
                      type='button'
                      className='btn btn-sm btn-outline-theme'
                      onClick={() => handleSelectAll('module', null, true)}
                    >
                      <i className='fas fa-check-square me-2'></i>
                      {t('SelectAll')}
                    </button>
                    <button
                      type='button'
                      className='btn btn-sm btn-outline-theme'
                      onClick={() => handleSelectAll('module', null, false)}
                    >
                      <i className='fas fa-square me-2'></i>
                      {t('UnSelectAll')}
                    </button>
                    <small className='text-muted'>
                      {getSelectedCount('General', 'module')}/{getTotalCount('General', 'module')} {t('Selected')}
                    </small>
                  </div>
                )}
              </div>

              <div className='col-xl-3 text-end'>
                <div className='d-flex gap-2 justify-content-end'>
                  {hasChanges && (
                    <button
                      type='button'
                      className='btn btn-outline-warning'
                      onClick={handleResetChanges}
                      title={t('ResetChanges')}
                    >
                      <i className='fa fa-undo fa-fw me-2'></i>
                      {t('Reset')}
                    </button>
                  )}
                  <button
                    disabled={isSubmitting || !hasChanges}
                    type='button'
                    className='btn btn-theme'
                    onClick={() => handleUpdatePermission()}
                  >
                    {isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fa fa-save fa-fw me-2'></i>
                    )}
                    {t('Save')}
                  </button>
                </div>
              </div>
            </div>

            {hasChanges && (
              <div className='row'>
                <div className='col-12'>
                  <div className='alert alert-warning alert-dismissible fade show py-2 mb-0 mt-2' role='alert'>
                    <i className='fa fa-exclamation-triangle me-2'></i>
                    {i18n.language === 'en' ? 'You Have Unsaved Changes' : 'لديك تغييرات غير محفوظة'}
                    {/* {t('YouHaveUnsavedChanges')} */}
                  </div>
                </div>
              </div>
            )}
          </CardHeader>

          <CardBody className='p-0'>
            <ul className='nav nav-tabs nav-tabs-v2 pt-1 px-3'>
              <li className='nav-item me-1 dropdown'>
                <Link
                  to='#/'
                  className='nav-link dropdown-toggle me-1 bg-theme bg-opacity-25 px-2'
                  data-bs-toggle='dropdown'
                >
                  <i className='fa fa-sliders-h fa-fw me-2 text-theme'></i>
                  {t('ApplicationPermissions')}
                  <span className='badge bg-theme ms-2'>
                    {getSelectedCount('General')}/{getTotalCount('General')}
                  </span>
                </Link>

                <div className='dropdown-menu text-center border-theme ' style={{ minWidth: '250px' }}>
                  {!moduleId && (
                    // Case 1: No module selected
                    <>
                      <i className='fa fa-mouse-pointer fa-3x text-warning mb-3'></i>
                      <h6 className='text-warning'>{i18n.language === 'en' ? 'Select Application' : 'اختر التطبيق'}</h6>

                      <p className='small text-muted mb-3'>
                        {i18n.language === 'en'
                          ? 'Please select an application to view permissions'
                          : 'يرجى اختيار تطبيق لعرض الصلاحيات'}
                      </p>
                    </>
                  )}
                  {PermissionList && PermissionList?.menuWithPermissions ? (
                    PermissionList.menuWithPermissions
                      .filter(f => !moduleId || f.moduleId === moduleId)
                      .sort((a, b) => a.sequence - b.sequence).length > 0 &&
                    PermissionList.menuWithPermissions
                      // .filter(f => !moduleId || f.moduleId === moduleId)
                      .filter(f => f.moduleId === moduleId)
                      .sort((a, b) => a.sequence - b.sequence)
                      .map(item => {
                        const itemPermissions = item.permissions || [];
                        const selectedCount = itemPermissions.filter(p => checkedPermissions[p.id]).length;
                        const totalCount = itemPermissions.length;

                        return (
                          <Link
                            to={`#${item.menuId}`}
                            key={item.menuId}
                            className='dropdown-item d-flex justify-content-between align-items-center'
                            onClick={() => setActiveTab(item.menuId)}
                            data-bs-toggle='tab'
                          >
                            <span>{i18n.language === 'ar' ? item.name2 : item.name}</span>
                            <small className='text-muted'>
                              {selectedCount}/{totalCount}
                            </small>
                          </Link>
                        );
                      })
                  ) : (
                    <></>
                  )}
                </div>
              </li>

              {DynamicPermission?.map(item => {
                const selectedCount = getSelectedCount('dynamic', item.type);
                const totalCount = getTotalCount('dynamic', item.type);

                return (
                  <li className='nav-item me-3' key={item.type}>
                    <Link to={`#${item.type}`} className='nav-link' data-bs-toggle='tab'>
                      {getIconForType(item.type)}
                      {item.permissionTypeName}
                      <span className='badge bg-theme ms-2'>
                        {selectedCount}/{totalCount}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>

            <div className='tab-content p-4'>
              {/* Existing tab content remains the same but with enhanced visual feedback */}
              {PermissionList?.menuWithPermissions
                ?.filter(f => !moduleId || f.moduleId === moduleId)
                ?.map(item => {
                  const filteredPermissions =
                    item.permissions
                      ?.slice()
                      ?.filter(f => f.menuId === item.menuId)
                      ?.sort((a, b) => a.sequence - b.sequence) || [];

                  const selectedCount = filteredPermissions.filter(p => checkedPermissions[p.id]).length;
                  const totalCount = filteredPermissions.length;

                  return (
                    <div
                      className={`tab-pane fade ${activeTab === item.menuId ? 'show active' : ''}`}
                      id={item.menuId}
                      key={item.menuId}
                    >
                      <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h6 className='mb-0 text-theme'>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                          <small className='text-muted ms-2'>
                            ({selectedCount}/{totalCount} {i18n.language === 'en' ? 'Selected' : 'تم الاختيار'})
                          </small>
                        </h6>
                        <div className='d-flex gap-2'>
                          <button
                            type='button'
                            className='btn btn-sm btn-outline-theme'
                            onClick={() => handleSelectAll('General', item.menuId, true)}
                          >
                            <i className='fas fa-check-square me-2'></i>
                            {t('SelectAll')}
                          </button>
                          <button
                            type='button'
                            className='btn btn-sm btn-outline-theme'
                            onClick={() => handleSelectAll('General', item.menuId, false)}
                          >
                            <i className='fas fa-square me-2'></i>
                            {t('UnSelectAll')}
                          </button>
                        </div>
                      </div>

                      <div className='row'>
                        {filteredPermissions.length > 0 ? (
                          filteredPermissions.map(m => {
                            const isChanged = originalPermissions[m.id] !== checkedPermissions[m.id];

                            return (
                              <div className='col-md-4 mb-2' key={m.id}>
                                <div
                                  className={`p-3 rounded-2 permission-item fw-bold ${
                                    checkedPermissions[m.id]
                                      ? 'border-theme border border-1 bg-theme bg-opacity-20'
                                      : 'border-theme border-bottom bg-inverse bg-opacity-10'
                                  } ${isChanged ? 'changed-permission' : ''}`}
                                  onClick={() => handleCheckboxChange(m.id, 'General')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div className='form-check'>
                                    <label className='form-check-label d-flex align-items-center' htmlFor={`${m.id}`}>
                                      <input
                                        className='form-check-input me-2'
                                        type='checkbox'
                                        id={`${m.id}`}
                                        checked={checkedPermissions[m.id] || false}
                                        onChange={() => {}}
                                        onClick={e => e.stopPropagation()}
                                      />
                                      <span className='flex-grow-1'>{i18n.language === 'ar' ? m.name2 : m.name}</span>
                                      {isChanged && (
                                        <i className='fa fa-circle text-warning' style={{ fontSize: '8px' }}></i>
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className='col-12'>
                            <NoData />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

              {/* Dynamic permissions tab content with similar enhancements */}
              {DynamicPermission?.map((item, index) => {
                const filteredDynamic =
                  PermissionList?.dynamic
                    ?.filter(f => f.permissionType === item.type)
                    ?.filter(f => !f.moduleId || f.moduleId === moduleId) || [];

                const selectedCount = filteredDynamic.filter(m => checkedPermissionsDynamic[m.id]).length;
                const totalCount = filteredDynamic.length;

                return (
                  <div className='tab-pane fade' id={item.type} key={index}>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <h6 className='mb-0 text-theme'>
                        {item.permissionTypeName}
                        <small className='text-muted ms-2'>
                          ({selectedCount}/{totalCount} {t('Selected')})
                        </small>
                      </h6>
                      <div className='d-flex gap-2'>
                        <button
                          type='button'
                          className='btn btn-sm btn-outline-theme'
                          onClick={() => handleSelectAll('dynamic', '', true, item.type)}
                        >
                          <i className='fas fa-check-square me-2'></i>
                          {t('SelectAll')}
                        </button>
                        <button
                          type='button'
                          className='btn btn-sm btn-outline-theme'
                          onClick={() => handleSelectAll('dynamic', '', false, item.type)}
                        >
                          <i className='fas fa-square me-2'></i>
                          {t('UnSelectAll')}
                        </button>
                      </div>
                    </div>

                    <div className='row g-2'>
                      {filteredDynamic.length > 0 ? (
                        filteredDynamic.map(m => {
                          const isChanged = originalDynamicPermissions[m.id] !== checkedPermissionsDynamic[m.id];

                          return (
                            <div className='col-md-4 mb-2' key={m.id}>
                              <div
                                className={`p-3 rounded-2 permission-item fw-bold ${
                                  checkedPermissionsDynamic[m.id]
                                    ? 'border-theme border border-1 bg-theme bg-opacity-20'
                                    : 'border-theme border-bottom bg-inverse bg-opacity-10'
                                } ${isChanged ? 'changed-permission' : ''}`}
                                onClick={() => handleCheckboxChange(m.id, 'dynamic')}
                                style={{ cursor: 'pointer' }}
                              >
                                <div className='form-check'>
                                  <label className='form-check-label d-flex align-items-center' htmlFor={`${m.id}`}>
                                    <input
                                      className='form-check-input me-2'
                                      type='checkbox'
                                      id={`${m.id}`}
                                      checked={checkedPermissionsDynamic[m.id] || false}
                                      onChange={() => {}}
                                      onClick={e => e.stopPropagation()}
                                    />
                                    <span className='flex-grow-1'>{i18n.language === 'ar' ? m.name2 : m.name}</span>
                                    {isChanged && (
                                      <i className='fa fa-circle text-warning' style={{ fontSize: '8px' }}></i>
                                    )}
                                  </label>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className='col-12'>
                          <NoData />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Card>
      </Loading>

      <style>
        {`
          .permission-item {
            transition: all 0.3s ease;
            cursor: pointer;
          }

          .permission-item:hover {
            background-color: rgba(var(--bs-theme-rgb), 0.4) !important;
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
          }

          .changed-permission {
            animation: pulse 2s infinite;
            border-left: 4px solid var(--bs-warning) !important;
          }

          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(var(--bs-warning-rgb), 0.7); }
            70% { box-shadow: 0 0 0 5px rgba(var(--bs-warning-rgb), 0); }
            100% { box-shadow: 0 0 0 0 rgba(var(--bs-warning-rgb), 0); }
          }

          .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .badge {
            font-size: 0.7em;
          }
        `}
      </style>
    </>
  );
};

export default Permissions;
